import { useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Box,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../../../App.css';
import { apiUrlPrefix } from '../../../config';


const ContactUsComponent = () => {
    const [error, setError] = useState(null);

    // --- MUTATION LOGIC ---
    const reportIssue = async ({ email, message }) => {
        // Since you are using 'multiple' in Autocomplete, 
        // 'users' is already the array you need!
        const apiUrl = apiUrlPrefix + 'Report/sendReport';

        const response = await fetch(apiUrl, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Name: email,
                Message: message
            }),
        });

        if (!response.ok) {
            if (response.status === 403) {
                throw new Error('Invalid credentials or permissions.');
            }
            throw new Error('Network response was not ok');
        }

        return response.json();
    };

    const reportIssueMutation = useMutation({
        mutationFn: reportIssue,
        onSuccess: (data) => {
            if (data) {
                console.log("DONE"); //TODO
            } else {
                throw new Error('Unexpected response structure');
            }
        },
        onError: (error) => {
            setError(error.message);
        },
    });

    const formik = useFormik({
        initialValues: {
            email: '',
            message: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Email is required'),
            message: Yup.string().required('Your message is required'),
        }),
        onSubmit: (values) => {
            setError(null);
            reportIssueMutation.mutate(values);
        },
    });

    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit} // This connects the button to your logic
            sx={{ p: 2 }}
        >
                        {/* Success message state */}
            {reportIssueMutation.isSuccess && (
                <Typography color="success.main" sx={{ mt: 2, textAlign: 'center', fontSize: '24px' }}>
                    Thank you, your message has been sent!
                </Typography>
            )}

            {/* EMAIL FIELD */}
            <TextField
                margin="dense"
                label="Email"
                fullWidth
                name="email" // Must match Formik initialValues
                value={formik.values.email} // Fixed from .title
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />

            {/* MESSAGE FIELD */}
            <TextField
                multiline
                rows={8}
                margin="dense"
                label="What would you like to contact us about?"
                fullWidth
                name="message" // Must match Formik initialValues
                value={formik.values.message} // Fixed from .title
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.message && Boolean(formik.errors.message)}
                helperText={formik.touched.message && formik.errors.message}
            />

            <Button
                className='buttonStyling'
                type="submit" // Triggers form onSubmit
                color="primary"
                disabled={reportIssueMutation.isPending} // use 'isPending' in TanStack Query v5
                sx={{ mt: 2 }}
            >
                {reportIssueMutation.isPending ? 'Sending...' : 'Send'}
            </Button>

            {error && (
                <Typography color="error" sx={{ mt: 2 }}>
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default ContactUsComponent;